import React, { Component } from 'react';
import CTModal from '../../helpers/CTModal';
import { SaveFileDialogContainer } from './SaveFileDialogContainer';
import { validateSaveForm, getNameByCodeFromList } from './utils';

class SaveFileDialog extends Component {
    state = {
        code: '',
        comment: '',
        name: '',
        saveFormIsValid: false,
        touched: { name: false, code: false, comment: false }
    };

    saveData = () => {
        if (this.state.saveFormIsValid) {
            this.props
                .setFileData(
                    this.props.selected,
                    {
                        name: this.state.name,
                        comments: this.state.comment,
                        code: this.state.code
                    },
                    this.props.code,
                    this.props.fileToSave
                )
                .finally(() => {
                    this.props.onAfterSave();
                    this.setState({
                        code: '',
                        name: '',
                        comment: '',
                        saveFormIsValid: validateSaveForm(this.props.code, {})
                    });
                });
        }
    };

    onChange = (name, value) => {
        this.setState(state => {
            const newState = { ...state };
            newState[name] = value;
            newState.saveFormIsValid = validateSaveForm(this.props.code, newState);

            return newState;
        });
    };
    onBlur = name => {
        this.setState(prevState => {
            const newTouchedState = { ...prevState.touched };
            newTouchedState[name] = true;

            return {
                touched: newTouchedState
            };
        });
    };

    render() {
        return (
            <CTModal
                open={this.props.isOpen}
                primaryButtonTitle="Save"
                primaryButton={true}
                primaryButtonClick={this.saveData}
                primaryButtonDisabled={!this.state.saveFormIsValid}
                secondaryButton={true}
                secondaryButtonClick={this.props.onClose}
                secondaryButtonTitle="Cancel"
                onClose={this.props.onClose}
                onOpen={() => {
                    const currentName = getNameByCodeFromList(
                        this.props.list,
                        this.props.code,
                        !!this.props.selected.selectedHotel.id
                    );

                    this.setState({
                        code: this.props.code,
                        name: this.props.code ? currentName : '',
                        comment: '',
                        saveFormIsValid: false
                    });
                }}
            >
                <div>
                    <h4 className="modal-save-mb-12">{`Save ${this.props.titleName} Changes`}</h4>
                    <div className="col-xs modal-save-mb-50">
                        <SaveFileDialogContainer
                            {...this.state}
                            titleName={this.props.titleName}
                            currentCode={this.props.code}
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                        />
                    </div>
                </div>
            </CTModal>
        );
    }
}

export default SaveFileDialog;



// WEBPACK FOOTER //
// ./src/components/modals/editFile/SaveFileDialog.js